import { TargetSchemaItem } from '../authentication-method-policy-utlity';
import {
    AuthenticationMethodPolicyMicrosoftAuthenticatorForm,
    AuthenticationMethodPolicyMicrosoftAuthenticatorSchema,
} from './model';

export function updateAuthenticationMethodsMicrosoftAuthenticatorSchema(
    form: AuthenticationMethodPolicyMicrosoftAuthenticatorForm,
): AuthenticationMethodPolicyMicrosoftAuthenticatorSchema {
    let includedTargetsOneOfItems: TargetSchemaItem[] = [];

    includedTargetsOneOfItems = form.includeTargets.includedGroups.map((group) => ({
        properties: {
            id: { type: 'string', const: group.id },
            targetType: { type: 'string', const: 'group' },
            authenticationMode: { type: 'string', const: group.authenticationMode || 'any' },
        },
    }));

    const excludeTargetsOneOfItems: TargetSchemaItem[] = form.excludeTargets.map((group) => ({
        properties: {
            id: { type: 'string', const: group },
            targetType: { type: 'string', const: 'group' },
        },
    }));

    return {
        type: 'object',
        properties: {
            state: { type: 'string', const: form.state },
            isSoftwareOathEnabled: {
                type: 'boolean',
                const: form.isSoftwareOathEnabled,
            },
            featureSettings: {
                type: 'object',
                properties: {
                    companionAppAllowedState: {
                        type: 'object',
                        properties: {
                            state: { type: 'string', const: form.featureSettings.companionAppAllowedState.state },
                            includeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const: form.featureSettings.companionAppAllowedState.includeTarget.id,
                                    },
                                },
                            },
                            excludeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const:
                                            form.featureSettings.companionAppAllowedState.excludeTarget.id ||
                                            '00000000-0000-0000-0000-000000000000',
                                    },
                                },
                            },
                        },
                    },
                    displayAppInformationRequiredState: {
                        type: 'object',
                        properties: {
                            state: {
                                type: 'string',
                                const: form.featureSettings.displayAppInformationRequiredState.state,
                            },
                            includeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const: form.featureSettings.displayAppInformationRequiredState.includeTarget.id,
                                    },
                                },
                            },
                            excludeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const:
                                            form.featureSettings.displayAppInformationRequiredState.excludeTarget.id ||
                                            '00000000-0000-0000-0000-000000000000',
                                    },
                                },
                            },
                        },
                    },
                    displayLocationInformationRequiredState: {
                        type: 'object',
                        properties: {
                            state: {
                                type: 'string',
                                const: form.featureSettings.displayLocationInformationRequiredState.state,
                            },
                            includeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const: form.featureSettings.displayLocationInformationRequiredState
                                            .includeTarget.id,
                                    },
                                },
                            },
                            excludeTarget: {
                                type: 'object',
                                properties: {
                                    id: {
                                        type: 'string',
                                        const:
                                            form.featureSettings.displayLocationInformationRequiredState.excludeTarget
                                                .id || '00000000-0000-0000-0000-000000000000',
                                    },
                                },
                            },
                        },
                    },
                },
            },
            includeTargets:
                includedTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: includedTargetsOneOfItems,
                          },
                          minItems: includedTargetsOneOfItems.length,
                          maxItems: includedTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },

            excludeTargets:
                excludeTargetsOneOfItems.length > 0
                    ? {
                          type: 'array',
                          items: {
                              type: 'object',
                              oneOf: excludeTargetsOneOfItems,
                          },
                          minItems: excludeTargetsOneOfItems.length,
                          maxItems: excludeTargetsOneOfItems.length,
                      }
                    : {
                          type: 'array',
                          maxItems: 0,
                      },
        },
    };
}
